"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Autogenerated by publish_packages.clj
const version = 'v0.19.20';
exports.default = version;
//# sourceMappingURL=version.js.map